import { render } from "./DettaglioAziendaGruppo.vue?vue&type=template&id=6bcf9804&ts=true"
import script from "./DettaglioAziendaGruppo.vue?vue&type=script&lang=ts"
export * from "./DettaglioAziendaGruppo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__